"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ValidatePasscodeResponseMapperV2 = void 0;
var ValidatePasscodeResponseMapperV2 = /** @class */ (function () {
    function ValidatePasscodeResponseMapperV2(data) {
        this.localData = data;
    }
    ValidatePasscodeResponseMapperV2.prototype.getDataObject = function () {
        return this.localData;
    };
    return ValidatePasscodeResponseMapperV2;
}());
exports.ValidatePasscodeResponseMapperV2 = ValidatePasscodeResponseMapperV2;
//# sourceMappingURL=ValidatePasscodeResponseMapperV2.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/login-ui/models/mappers/ValidatePasscodeResponseMapperV2.js
// module id = 1500
// module chunks = 8